/**
 * External dependencies
 */
import { useDispatch as BaseUseDispatch } from 'react-redux';
import { Action, AnyAction } from 'redux';
import { ThunkDispatch } from 'redux-thunk';

/**
 * Internal dependencies
 */
import { Models } from '@naruto/bgdapp/src/providers/initializeModel/types';
import { MiddleWare } from '@naruto/bgdapp/src/providers/initializeMiddleware/types';

/**
 * 描述 : Redux 派送實例
 */
export type UseDispatch<T extends Action = AnyAction> = () => ThunkDispatch<Models, MiddleWare, T>;
const useDispatch: UseDispatch = BaseUseDispatch;

export default useDispatch;
